<template>
  <div>
    <el-form label-width="170px" class="xzformitemmb">
      <el-row>
        <panel title="贷款信息" border>
          <el-col :span="12">
            <el-form-item label="贷款编号 ：">
              {{financingDetailData.fi__transactionNo}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="贷款状态：">
              {{'Financing_'+ financingDetailData.fi__transactionStatus|Status2CN}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户名称：">
              {{financingDetailData.fi__customerName}}
            </el-form-item>
            <el-form-item label="合同编号：">
              {{financingDetailData.fi__contractNo}}
            </el-form-item>
            <el-form-item label="贷款金额：">
              {{financingDetailData.fi__totalAmount|formatMoney}} 元
            </el-form-item>
            <el-form-item label="贷款开始日期：">
              {{financingDetailData.fi__startDate|moment('YYYY-MM-DD')}}
            </el-form-item>
            <el-form-item label="贷款申请日期：">
              {{financingDetailData.fi__transactionDate|moment('YYYY-MM-DD')}}
            </el-form-item>
            <el-form-item label="贷款月利率：">
              {{financingDetailData.fi__interestRate}}% （{{financingDetailData.fi__interestType|Status2CN}}）
            </el-form-item>
            <el-form-item label="利息收取节点：">
              {{financingDetailData.fi__interestPayTime}}
            </el-form-item>
            <el-form-item label="还款方式：">
              {{financingDetailData.fi__repaymentFormula|repaymentFormula2CN}}
            </el-form-item>
            <!--<el-form-item label="保理管理费收费类型：">
              {{financingDetailData.fi__lendingFeeType}}
            </el-form-item>-->
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户手机号：">
              {{financingDetailData.i__contactTelNo}}
            </el-form-item>
            <el-form-item label="贷款产品：">
              {{financingDetailData.ct__productName}}
            </el-form-item>
            <el-form-item label="币别：">
              {{financingDetailData.pi__currencyCode||'人民币'}}
            </el-form-item>
            <el-form-item label="贷款结束日期：">
              {{financingDetailData.fi__endDate|moment('YYYY-MM-DD')}}
            </el-form-item>
            <el-form-item label="贷款比例：">
              {{financingDetailData.ct__financingRatio}}%
            </el-form-item>
            <el-form-item label="服务费：">
              {{financingDetailData.fi__lendingFee|formatMoney}} {{financingDetailData.fi__lendingFeeType=='Rate' ? '%' : '元'}}
            </el-form-item>
            <el-form-item label="费用收取节点：">
              {{financingDetailData.fi__lendingFeePayTime}}
            </el-form-item>
            <el-form-item label="还款期数（月）：">
              {{financingDetailData.fi__repaymentCount}}
              <el-button type="primary" size="mini" icon="el-icon-more" @click="viewRepayPlay">查看还款计划</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="贷款用途：">
              {{financingDetailData.fi__intendedUse}}
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="financingDetailData.detail">
            <el-form-item label="审核意见：">
              {{financingDetailData.detail.map(item=>item['a__remarks'])}}
            </el-form-item>
          </el-col>
        </panel>
      </el-row>
    </el-form>
   <!-- <panel title="应收账款列表">
      <invoices-data-table :invoices="financingDetailData.invoices" :columns="invoiceColumns"></invoices-data-table>
    </panel>-->
    <panel title="">
      <files-data-table :files="financingDetailData.files"></files-data-table>
    </panel>
    <el-dialog title="查看还款计划" :visible.sync="repaymentDialogVisible">
      <repay-plan-data-table :data="repaymentPlanList"></repay-plan-data-table>
    </el-dialog>
  </div>
</template>

<script>
  import Panel from '../../components/Panel'
  import InvoicesDataTable from './InvoicesDataTable'
  import FilesDataTable from '../../components/FilesDataTable'
  import RepayPlanDataTable from './RepayPlanDataTable'
  import repaymentFormulaOptions from '../../utils/repaymentFormulaOptions'
  import Status2CN from '../../filters/Status2CN'
  import moment from 'moment'
  import {formatMoney} from "../../filters/CommonFilters";

  export default {
    name: "FinancingDetailComponent",
    data() {
      return {
        repaymentDialogVisible: false,
        invoiceColumns: [
          {
            name: '单据类型',
            field: 'pi__invoiceType'
          },
          {
            name: '单据号码',
            field: 'pi__invoiceNo'
          },
          {
            name: '单据金额',
            field: 'pi__totalAmount',
            formatter: function(r,c,v) {
              return formatMoney(v)+'元'
            }
          },
          {
            name: '质押金额',
            field: 'pi__pledgeAmount',
            formatter: function(r,c,v) {
              return formatMoney(v)+'元'
            }
          },
          {
            name: '币种',
            field: 'pi__currencyCode',
            formatter: function(r,c,v) {
              return '人民币'
            }
          },
          {
            name: '单据日期',
            field: 'pi__invoiceDate',
          },
          {
            name: '到期日',
            field: 'pi__dueDate',
          },
          {
            name: '本次融资金额',
            field: 'pi__financingAmount',
            formatter: function(r,c,v) {
              return formatMoney(v)+'元'
            }
          },
        ]
      }
    },
    props: {
      repaymentPlanList: {
        type: Object,
        default: ()=>{
          return {}
        }
      },
      financingDetailData : {
        type: Object,
        default: ()=>{
          return {
            invoices:[],
            files:[],
            detail: []
          }
        }
      },
      /*contractData: {
        type: Object,
        default:()=>{
          return {

          }
        }
      }*/
    },
    components: {
      Panel,
      InvoicesDataTable,
      RepayPlanDataTable,
      FilesDataTable
    },
    filters: {
      repaymentFormula2CN: function (val) {
        if(val) {
          let repaymentFormula = (repaymentFormulaOptions.filter(item=>item.value==val)).shift()
          if(repaymentFormula)
            return repaymentFormula.label
          else return val
        }
        else return val
      },
      Status2CN
    },
    methods: {
      viewRepayPlay: function () {
        this.repaymentDialogVisible = true
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/FinancingDetailComponent.vue